// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__fDQP5","shimmer":"skeleton_shimmer__JkSg4"};